import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { IoIosArrowForward } from 'react-icons/io';
import { login } from "../helper/SecurityHelper";
import { fn_loginHandlerCallback } from "../api/FnCmmn";
import Footer from '../components/Footer';
import NavbarText from '../components/NavbarText';
import SignatureCard from '../components/modal/SignatureCard';
import FirstInfo from '../components/signUp/FirstInfo';
import SecondInfo from '../components/signUp/SecondInfo';
import SearchCompany from '../components/signUp/SearchCompany';
import SelectSctrGb from "../components/signUp/SelectSctrGb";
import Snackbar from '../components/Snackbar';
import Terms from '../components/modal/Terms';

export default function SignUp() {
  const navigate = useNavigate();
  const location = useLocation();
  // const kakaoId = location.state.kakaoId;
  const [tab, setTab] = useState(0);
  const [isPhnCnfrmd, setIsPhnCnfrmd] = useState(false);
  const [authCode, setAuthCode] = useState('');
  const [sentSms, setSentSms] = useState(false);
  const [phoneNum, setPhoneNum] = useState('');
  const [userName, setUserName] = useState('');
  const [sex, setSex] = useState('');
  const [birth, setBirth] = useState('');
  const [password, setPassword] = useState('');
  const [notWok, setNotWok] = useState(false);
  const [terms1, setTerms1] = useState(false);
  const [terms2, setTerms2] = useState(false);
  const [terms3, setTerms3] = useState(false);
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [signatureCard, setSignatureCard] = useState(false);
  const [signature, setSignature] = useState('');
  const [cfrmChk, setCfrmChk] = useState(false);
  const [auth, setAuth] = useState('');
  const [fileName, setFileName] = useState('');
  const [files, setFiles] = useState([]);
  const [filesName, setFilesName] = useState([]);
  const [companyPopup, setCompanyPopup] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [cmpnySeq, setCmpnySeq] = useState<any>();
  const [cmpnyType, setCmpnyType] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const outputRef = useRef<HTMLImageElement>(null);
  const [useAgrChk, setUseAgrChk] = useState(false);
  const [isSctrGbPopOpen, setIsSctrGbPopOpen] = useState(false);
  const [selectedSctrGb, setSelectedSctrGb] = useState('');
  const btnRef = useRef<any>();
  const [saving, setSaving] = useState(false);
  const [tabMoving, setTabMoving] = useState(false);
  const [snackbarTxt, setSnackbarTxt] = useState('');
  const [loginProcess, setLoginProcess] = useState(true);

  useEffect(() => {
    if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 3000) }
  }, [snackbarTxt]);

  const backEvent = () => {
    if (tab === 0 && (sentSms || notWok || isPhnCnfrmd) && loginProcess) { setSentSms(false); setNotWok(false); setIsPhnCnfrmd(false); }
    else if (tab === 0 && (sentSms || notWok || isPhnCnfrmd) && !loginProcess) {
      setLoginProcess(true);
      setAuthCode('');
    } else if (tab === 0 && (!sentSms || !notWok || !isPhnCnfrmd) && loginProcess) {
      navigate('/');
    }
    else {
      if (tab === 3 && signature) { setTabMoving(true); }
      setTab(tab-1)
    }
  };

  useEffect(() => {
    if (companyPopup === false && companyName === '무소속') { setIsSctrGbPopOpen(true); }
  }, [companyPopup]);

  const nextHandler = () => {
    setCompanyPopup(false);
    fn_loginStrtBtn();
  }

  const handleChangeFile = (e: any) => {
    for (let key in e.target.files) {
      if (typeof e.target.files[key] === "object") {
        // @ts-ignore
        files.unshift(e.target.files[key]);
        // @ts-ignore
        filesName.unshift(e.target.files[key].name);
      }
    }
    setFiles(files);
    setFilesName([...filesName]);
  }

  const removeFile = (e: any) => {
    filesName.splice(e.target.value, 1);
    setFilesName([...filesName]);
    files.splice(e.target.value, 1);
    setFiles(files);
  }

  const fn_loginStrtBtn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  };

  useEffect(() => { if (saving) { fn_loginTbmStrt(); } }, [saving]);

  const fn_loginTbmStrt = async () => {
    let authSeq = 0;
    const formData = new FormData();
    let paramCmpnySeq = cmpnySeq;
    let apprYn = 'Y';
    let paramBirth = birth;

    if (companyName === '') {
      setSnackbarTxt('업체를 선택해 주십시오.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      return;
    }

    if (auth === 'WOK') {
      authSeq = 4;
    } else if (auth === 'SRV') {
      authSeq = 3;
      const rtrnData = await axios.post('admin/api/cmpny/cmpnyDtl/retrieveCmpnyAssignYn', {cmpnySeq:paramCmpnySeq});
      if(rtrnData.data.assignYn === 'Y') { apprYn = 'W'; };
    } else if (auth === 'COM') {
      authSeq = 2;
    }

    if (companyName === '무소속') {
      authSeq = 4;
      let sctrGbCd = selectedSctrGb;
      const rtrnData = await axios.post('admin/api/sgst/retrieveNonBlngCmpnySeq', { sctrGbCd: sctrGbCd });
      paramCmpnySeq = rtrnData.data;
    }

    // if (auth === 'COM' || auth === 'SRV') {
    //   if (!useAgrChk) {
    //     setSnackbarTxt('서비스 이용 약관에 동의해 주십시오.');
    //     btnRef.current.removeAttribute("readonly");
    //     setSaving(false);
    //     return;
    //   }
    // }

    // if (auth === 'SRV') {
    //   if (files.length === 0) {
    //     formData.append('multipartFiles', fileRef.current.files[0]);
    //     // setSnackbarTxt('현장대리인 필수 서류를 첨부해주세요.');
    //     // btnRef.current.removeAttribute("readonly");
    //     // setSaving(false);
    //     // return;
    //   } else {
    //     for (let i = 0; i < files.length; i++) {
    //       formData.append('multipartFiles_' + i, files[i]);
    //     }
    //   }
    // }
    //
    // if (auth === 'WOK' && fileName !== '') {
    //   formData.append('multipartFiles', fileRef.current.files[0]);
    // }

    let userPhoneNum = phoneNum.replaceAll('-', '');
    const jsonObject = {
      userNm: userName,
      userPhonNum: userPhoneNum,
      cmpnySeq: paramCmpnySeq,
      birthday: paramBirth,
      gender: sex,
      apprYn: apprYn,
      authSeq: authSeq,
      inputPassword: password,
      sign: signature,
      // kakaoId: kakaoId
    };
    formData.append('jsonData', JSON.stringify(jsonObject));
    let rtrnData = await axios.post('admin/api/user/saveUserData', formData);
    if (rtrnData.data.rsltCnt > 0) {
      const encryptedPhone = await axios.post('admin/api/cmmn/encryptedPhone', {phone: userPhoneNum});
      localStorage.setItem("SAVE_USER_ID", encryptedPhone.data); // 전화번호 암호화해서 localStorage에 저장
      login(userPhoneNum, auth, password, async (user: any) => {
        if (user) {
          const isFromSignUp = true;
          await fn_loginHandlerCallback(user, navigate, isFromSignUp, selectedSctrGb);
        }
      })
    } else {
      setSnackbarTxt(rtrnData.data.errMsg);
    }
  }

  useEffect(() => {
    let scrollPosition = 0;
    if (signatureCard) {
      scrollPosition = window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-(${scrollPosition}+120)px`;
      document.body.style.width = '100%';
    } else {
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      window.scrollTo(0, scrollPosition);
    }
  }, [signatureCard]);

  return (
    <div className='w-screen h-[calc(100dvh)] relative z-20'>
      {terms1 && <Terms setTerms1={setTerms1} setCheck1={setCheck1} terms1 />} {terms2 && <Terms setTerms2={setTerms2} setCheck2={setCheck2} terms2 />} {terms3 && <Terms setTerms3={setTerms3} setCheck3={setCheck3} terms3 />}
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      {signatureCard && <SignatureCard signature={signature} setSignature={setSignature} setSignatureCard={setSignatureCard} outputRef={outputRef} />}
      {companyPopup && <SearchCompany setCompanyName={setCompanyName} setCompanyPopup={setCompanyPopup} companyName={companyName} setCmpnySeq={setCmpnySeq} setCmpnyType={setCmpnyType} setAuth={setAuth} selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} setSnackbarTxt={setSnackbarTxt} nextHandler={nextHandler} auth={auth} />}
      {isSctrGbPopOpen && <SelectSctrGb signUp selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} setIsSctrGbPopOpen={setIsSctrGbPopOpen} />}

      <NavbarText backEvent={backEvent} noneMenu>{loginProcess ? '로그인' : '회원가입' }</NavbarText>
      <Tab tab={tab} />
      {tab !== 4 &&
        <FirstInfo signature={signature} setSignature={setSignature} outputRef={outputRef} tab={tab} setTab={setTab} setPhoneNum={setPhoneNum} setUserName={setUserName} setSnackbarTxt={setSnackbarTxt} password={password} setPassword={setPassword} isPhnCnfrmd={isPhnCnfrmd} setIsPhnCnfrmd={setIsPhnCnfrmd} tabMoving={tabMoving} setTabMoving={setTabMoving} auth={auth} setAuth={setAuth} sentSms={sentSms} setSentSms={setSentSms} authCode={authCode} setAuthCode={setAuthCode}
                   birth={birth} setBirth={setBirth} sex={sex} setSex={setSex} check1={check1} setCheck1={setCheck1} check2={check2} setCheck2={setCheck2} check3={check3} setCheck3={setCheck3} phoneNum={phoneNum} userName={userName} setTerms1={setTerms1} setTerms2={setTerms2} setTerms3={setTerms3} cfrmChk={cfrmChk} setCfrmChk={setCfrmChk} loginProcess={loginProcess} setLoginProcess={setLoginProcess} notWok={notWok} setNotWok={setNotWok} /> }
      {!loginProcess && tab === 4 &&
        <SecondInfo auth={auth} setAuth={setAuth} fileName={fileName} setFileName={setFileName} filesName={filesName} handleChangeFile={handleChangeFile} removeFile={removeFile} fileRef={fileRef} btnRef={btnRef} fn_loginStrtBtn={fn_loginStrtBtn} setUseAgrChk={setUseAgrChk} useAgrChk={useAgrChk}
                    setCompanyName={setCompanyName} setCmpnySeq={setCmpnySeq} setCompanyPopup={setCompanyPopup} companyName={companyName} setIsSctrGbPopOpen={setIsSctrGbPopOpen} /> }
      <Footer />
    </div>
  );
}

const Tab = ({ tab }: any) => {
  return (
    <div className='w-full h-55 md:h-[137px] flex items-center justify-center top-52 md:top-[130px] bg-back text-15 md:text-37'>
      <p className={tab !== 4 ? 'text-point font-preLight' : 'font-preLight'}>➀ 본인 정보 입력</p>
      <IoIosArrowForward className={tab !== 4 ? 'text-point mx-25 md:mx-[62px]' : 'mx-25 md:mx-[62px]'} />
      <p className={tab !== 4 ? 'font-preLight' : 'text-point font-preLight'}>➁ 업체 선택</p>
    </div>
  );
};